module.exports = __webpack_public_path__ + "img/culture_s_offre.3de0d44c.jpg";